import type { FaireProductEntity } from "../../entity_types/product";

export const p_g548sdahe5: FaireProductEntity = {
  token: "p_g548sdahe5",
  type: "product",
  name: "Eco Maui 13 oz. Cocktail",
  brandName: "Hospitality Glass",
  imageUrl:
    "https://cdn.faire.com/fastly/32fe62c9e7e4fedbb8411e2414c8bbb0f7f5ac3b9b4109c012312bf8b941b254.webp",
  priceDollars: 8.16,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/22255ec01b6063498142712f464e8195d3c0edb4be71cb3d49d77738ac1be22d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
